import { apiClient } from "./client";
import type { Assignment } from "./types";

export type ReportAbsenceResponse = {
  assignment: Assignment;
  candidates_notified: number;
};

export async function reportAbsence(
  assignmentId: string,
  reason?: string | null,
): Promise<ReportAbsenceResponse> {
  const { data } = await apiClient.post<ReportAbsenceResponse>(
    `/api/v1/me/assignments/${assignmentId}/report-absence`,
    { reason: reason || null },
  );
  return data;
}

export type CoverageRequest = {
  assignment: Assignment;
  organization_id: string;
  organization_name: string;
  slot_label: string;
  slot_start: string;
  slot_end: string;
};

export async function listCoverageRequests(): Promise<CoverageRequest[]> {
  const { data } = await apiClient.get<CoverageRequest[]>(
    "/api/v1/me/coverage-requests",
  );
  return data;
}

export type TakeOverResponse = {
  backup_assignment: Assignment;
};

export async function takeOverCoverage(
  absentAssignmentId: string,
): Promise<TakeOverResponse> {
  const { data } = await apiClient.post<TakeOverResponse>(
    `/api/v1/me/coverage-requests/${absentAssignmentId}/take-over`,
  );
  return data;
}
